export default __webpack_public_path__ + "static/confetti-stamps-large-d5f39d1749fffdb911c86d0a6a437c5a.svg";